import React from 'react';

export default function Services() {
  const services = [
    {
      icon: "fa-desktop",
      title: "Tecnología de Punta",
      desc: "Equipos de última generación, cámaras HD e iluminación profesional para garantizar la mejor calidad de transmisión."
    },
    {
      icon: "fa-usd",
      title: "Pagos Puntuales",
      desc: "Pagos semanales y quincenales, con porcentajes escalables del 55% al 65% para recompensar tu esfuerzo."
    },
    {
      icon: "fa-building",
      title: "Habitaciones de Lujo",
      desc: "Espacios individuales y temáticos diseñados para tu comodidad y privacidad, permitiéndote expresar tu estilo único."
    },
    {
      icon: "fa-calendar",
      title: "Horarios Flexibles",
      desc: "Tú eliges cuándo trabajar. Nuestro estudio está abierto 24/7 para adaptarse a tu estilo de vida."
    },
    {
      icon: "fa-map-marker",
      title: "Ubicación Estratégica",
      desc: "Situados en una zona segura de Armenia, con fácil acceso a transporte y servicios esenciales."
    },
    {
      icon: "fa-shopping-bag",
      title: "Capacitación Continua",
      desc: "Te formamos en técnicas de transmisión, marketing y manejo de redes para potenciar tu carrera."
    },
    {
      icon: "fa-rss", // satellite-dish might not be in the version of FA they use, fa-rss is safer or check index.html
      title: "Modelos Satélite",
      desc: "Trabaja desde casa con nuestro soporte técnico y logístico completo, manteniendo los estándares del estudio."
    },
    {
      icon: "fa-users",
      title: "Programa de Referidos",
      desc: "Gana bonificaciones especiales por traer nuevos talentos a nuestro equipo. ¡Crecemos juntas!"
    }
  ];

  return (
    <section id="services">
      <div className="container wow fadeInUp">
        <div className="row">
          <div className="col-md-12">
            <h2 className="section-title">Nuestros Servicios</h2>
            <div className="section-title-divider"></div>
            <p className="section-description text-center text-white" style={{ color: '#aaa', textAlign: 'center' }}>
              Descubre por qué somos el estudio líder en Armenia. Te ofrecemos las mejores herramientas para tu éxito.
            </p>
          </div>
        </div>

        <div className="row">
          {services.map((service, index) => (
            <div className="col-md-4 col-sm-6 mb-5" key={index}>
              <div className="service-item wow fadeInUp" data-wow-delay={`${0.1 * (index + 1)}s`}>
                <div className="service-icon">
                  <i className={`fa ${service.icon}`}></i>
                </div>
                <h4 className="service-title">{service.title}</h4>
                <p className="service-description">
                  {service.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
